import { createApp } from 'vue'
import { createStore } from 'vuex'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.css"
import liff from '@line/liff'

const app = createApp(App)

var store = createStore({
    state: {
        is_test: false,
        loading: false,
        channel_id: null,
        access_token: null,
        error: {}
    },
    mutations: {
        set_state(state, p){
            for (var param of Object.keys(p)){
                state[param] = p[param]
            }
        }
    },
    actions: {
        launch_survey(context, p){
            var default_error = {
                severity: "danger",
                message: "アンケートを起動できませんでした。"
            }

            if (!(store.state.channel_id && p.survey_id)){
                console.error(`channel_id or survey_id is not set.`)
                context.commit("set_state", { error: { message: "Channel IDまたはアンケートIDがセットされていません。"} })
                return
            }
            
            if (!store.state.access_token){
                console.error(`channel_id or survey_id is not set.`)
                context.commit("set_state", { error: { message: "Access tokenがセットされていません。"} })
                return
            }

            context.commit("set_state", { loading: true })

            var xhr = new XMLHttpRequest()

            // Set endpoint URL.
            var url = "/api/launcher/survey/" + encodeURIComponent(p.survey_id)

            xhr.open('GET', url, true);

            // Set header.
            xhr.setRequestHeader("Govtech-Channel", store.state.channel_id)
            xhr.setRequestHeader("Authorization", store.state.access_token)

            // Set onload callback. 
            xhr.onload = function(){
                var response 
                try {
                    response = JSON.parse(xhr.response)
                } catch(e){
                    response = null
                }
                if (response && response.success){
                    // Close LIFF and Go to Talk room.
                    liff.closeWindow()
                    if (response.redirect_uri){
                        location.href = response.redirect_uri
                    }
                } else {
                    // レスポンス形式が異なるバリデーションエラーには汎用メッセージを表示する。
                    context.commit("set_state", {
                        error: response && response.error && response.error.message
                            ? response.error
                            : default_error
                    })
                }
                context.commit("set_state", { loading: false })
            }

            // Set error callback.
            xhr.onerror = function(){
                context.commit("set_state", { loading: false, error: default_error })
            }

            // Make callout.
            xhr.send(null)
        }
    }
})

var liff_state = get_query("liff.state")
var liff_id, channel_id, survey_id

// liff_state should have been set when URL is https://liff.line.me
if (liff_state){
    console.log("liff.state found.")
    var query = decodeURIComponent(liff_state)
    var params = new URLSearchParams(decodeURIComponent(query))
    liff_id = params.get("liff_id")
    channel_id = params.get("channel_id")
    survey_id = params.get("survey_id")
}

// Try to get liff_id from query string. When URL is line://app/xx, liff_id should have been directly set to query string.
if (!liff_id){
    liff_id = get_query("liff_id")
}

console.log("liff_id is " + liff_id)

liff.init({
    liffId: liff_id || "1654142937-NGb0Wqzz",
    withLoginOnExternalBrowser: false,
}).then(function(){
    console.log("LIFF initialization completed.")
    channel_id = channel_id || get_query("channel_id")
    survey_id = survey_id || get_query("survey_id")
    store.commit("set_state", { channel_id })
    store.commit("set_state", { survey_id })

    if (liff.isInClient() || liff.isLoggedIn()){
        console.log("Client is in LIFF.")
        store.commit("set_state", { access_token: liff.getAccessToken() })
        store.dispatch("launch_survey", { survey_id })
    } else {
        store.commit("set_state", { error: { message: "LINEアプリのカメラでQRコードを読み込むか、LINEアプリ内でURLにアクセスしてください。"}})
    }
}).catch(function(e){
    store.commit("set_state", { error: e })
})

app.use(store).mount('#app')

function get_query(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
